import _ from "lodash";
import { updateAttachmentMutation } from "./PdfTronViewerMutation";
import client from "lib/apolloClient/client";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

export const updateAttachmentPdfTron = ({
  newAttachment,
  showToast = true,
}) => {
  return async dispatch => {
    const response = await client.mutate({
      mutation: updateAttachmentMutation,
      variables: {
        newAttachment: _.omit(newAttachment, "isRead"),
      },
    });

    if (showToast) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:saved_successfully",
          type: "success",
          position: "toast-bottom-left",
        })
      );
    }

    return _.get(response, "data.platform.updateAttachment", {});
  };
};

export const controlHandleConstants = {
  outlineColor: "#008392",
  color: "white",
  handleWidth: 9,
  handleHeight: 9,
  selectionOutlineThickness: 1,
  defaultSelectionOutlineColor: "#008392",
  defaultNoPermissionSelectionOutlineColor: "#008392",
};
